import { useBaseListView } from '@/common/view/useBaseListView';
import { useCrudActions } from '@/common/view/useCrudActions';
import { creditService } from '@/services/credit';

export function useCreditList() {
    const { list, total, fetchList } = useBaseListView({ request: creditService.ticket.list });

    const actions = {
        remove: useCrudActions().confirmAndRemove({
            request: creditService.ticket.remove,
            onSuccess: () => fetchList()
        })
    };

    return { list, total, actions, fetchList };
}
